import {baseUrl} from '../shared/baseUrl';


export const resetPasswordRequest = (email) =>{
    return fetch(baseUrl+'users/resetPassword',{
        method: 'POST',
        body:JSON.stringify({
            email:email
        }),
        headers: {
            "Content-Type": "application/json"
          },
        credentials: 'same-origin'
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}

export const resetPasswordChange = (email,password,token) =>{
    return fetch(baseUrl+'users/resetPassword',{
        method: 'PUT',
        body:JSON.stringify({
            email:email,
            password:password,
            token:token
        }),
        headers: {
            "Content-Type": "application/json"
          },
        credentials: 'same-origin'
    })
    .then(response=>{
        return response.json();
    })
    .catch((err)=>console.log(err));
}